import { render, staticRenderFns } from "./editpara.vue?vue&type=template&id=78237ed9&scoped=true"
import script from "./editpara.vue?vue&type=script&lang=js"
export * from "./editpara.vue?vue&type=script&lang=js"
import style0 from "./editpara.vue?vue&type=style&index=0&id=78237ed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78237ed9",
  null
  
)

export default component.exports